"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReturnDeclarationRequestPayloadTrackingDataToJSON = exports.ReturnDeclarationRequestPayloadTrackingDataFromJSONTyped = exports.ReturnDeclarationRequestPayloadTrackingDataFromJSON = void 0;
function ReturnDeclarationRequestPayloadTrackingDataFromJSON(json) {
    return ReturnDeclarationRequestPayloadTrackingDataFromJSONTyped(json, false);
}
exports.ReturnDeclarationRequestPayloadTrackingDataFromJSON = ReturnDeclarationRequestPayloadTrackingDataFromJSON;
function ReturnDeclarationRequestPayloadTrackingDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'date': json['date'],
        'trackingId': json['trackingId'],
    };
}
exports.ReturnDeclarationRequestPayloadTrackingDataFromJSONTyped = ReturnDeclarationRequestPayloadTrackingDataFromJSONTyped;
function ReturnDeclarationRequestPayloadTrackingDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'date': value.date,
        'trackingId': value.trackingId,
    };
}
exports.ReturnDeclarationRequestPayloadTrackingDataToJSON = ReturnDeclarationRequestPayloadTrackingDataToJSON;
//# sourceMappingURL=ReturnDeclarationRequestPayloadTrackingData.js.map